import { DEFAULT_VERIFICATION_MODE, DEFAULT_VERIFICATION_WAIT_HOURS, VERIFICATION_CONDITION_CATALOG, VERIFICATION_MODES, VERIFICATION_WAIT_HOURS_OPTIONS, } from './catalog';
export function resolvePlaybookVerification(raw) {
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw))
        return null;
    const obj = raw;
    if (obj.enabled !== true)
        return null;
    const waitHours = VERIFICATION_WAIT_HOURS_OPTIONS.includes(obj.waitHours)
        ? obj.waitHours
        : DEFAULT_VERIFICATION_WAIT_HOURS;
    const rawConditions = typeof obj.conditions === 'object' && obj.conditions !== null && !Array.isArray(obj.conditions)
        ? obj.conditions
        : {};
    const conditions = {};
    for (const def of VERIFICATION_CONDITION_CATALOG) {
        const value = rawConditions[def.id];
        conditions[def.id] = typeof value === 'boolean' ? value : def.defaultEnabled;
    }
    const templateId = typeof obj.templateId === 'string' && obj.templateId.length > 0 ? obj.templateId : null;
    const mode = VERIFICATION_MODES.includes(obj.mode)
        ? obj.mode
        : DEFAULT_VERIFICATION_MODE;
    const targetPlaybookId = typeof obj.targetPlaybookId === 'string' && obj.targetPlaybookId.length > 0
        ? obj.targetPlaybookId
        : null;
    return {
        waitHours,
        conditions: conditions,
        templateId,
        mode,
        targetPlaybookId,
    };
}
/** `true` quando ao menos uma condição está ligada (nenhuma ligada ⇒ nunca agenda — mockup). */
export function anyVerificationConditionEnabled(config) {
    return VERIFICATION_CONDITION_CATALOG.some((def) => config.conditions[def.id]);
}
//# sourceMappingURL=resolve.js.map